<template>
  <div class="match-com">
    {{ $t("corporate.result_soon") }}
    <!--transition name="el-fade-in-linear">
      <div>
        <div class="tab-header">
          <div
            v-for="(tab, index) in tabsname"
            :key="index"
            :class="['tab', { active: activeParent === tab.id }]"
            @click="changeParentTab(tab.id)"
          >
          {{ $t('corporate.' + tab.label) }}
          </div>
        </div>
        <div class="tab-header">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            :class="['tab', { active: activeTab === tab.id }]"
            @click="changeTab(tab.id)"
          >
          {{ $t('corporate.' + tab.label) }}
          </div>
        </div>
        <div class="tab-content">
          // Content of the active tab
          <ScheduleResult
            v-loading="metchLoading"
            :roundList="schedule_rounds"
            :activeTab="this.activeTab"
            :activeParent="this.activeParent"
            ref="current"
          />
        </div>
      </div>
    </transition-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BasketballApi } from "../../../api/basketball";
import ScheduleResult from "../../components/corporate/ScheduleResult.vue";

export default {
  props: ["latestLists", "roundList", "tabid", "team", "currentIndex", "tabnames"],
  components: {
    ScheduleResult,
  },
  data() {
    return {
      teamvalue: "",
      selectValue: "",
      metchLoading: false,
      monthnum: "",
      matchId: "",
      matchShow: true,
      matchstate: false,
      showcom: "Schedule1",
      matchData: "",
      tabsname: [
        {
          id: "men",
          label: "men_tournament",
        },
        {
          id: "open",
          label: "open_tournament",
        },
      ],
      tabs: [
        {
          id: "g",
          label: "group_matches_category",
        },
        {
          id: "s",
          label: "semi_final_category",
        },
        {
          id: "f",
          label: "final_category",
        },
      ],
      activeParent: "men",
      activeTab: "g",
      schedule_rounds: [],
      schedule_rounds_total: 0,
      type: "g",
      category: "men"
    };
  },
  computed: {
    ...mapState(["headType"]),
  },
  created() {
    this.getTournamentList();
  },
  methods: {
    getTournamentList() {
      this.metchLoading = true;
      BasketballApi.getCorporateTournament(this.type, this.category)
        .then((response) => {
          this.schedule_rounds = response.data.data;
          this.schedule_rounds_total = response.data.data.length;
          this.metchLoading = false;
        })
        .catch(() => {
          this.metchLoading = false;
        });
    },
    changeTab(id) {
      (this.type = id), (this.activeTab = id), this.getTournamentList();
    },
    changeParentTab(id) {
      (this.category = id), (this.activeParent = id), this.getTournamentList();
    }
  },
};
</script>

<style lang="scss">
.match-com {
  padding: 20px;
  h3 {
    text-align: left;
  }
  gap: 10px;
  .select {
    height: 130px;
    border-bottom: 2px solid #eff1f7;
    .el-select {
      margin: 40px 50px 0 0;
      width: 203px;
      border: none;
      float: right;
      .el-input {
        .el-select__caret {
          color: #318bc8;
        }
        .el-input__inner {
          height: 47px;
          border: 1px solid #318bc8;
          border-radius: 15px;
          color: #318bc8 !important;
        }
      }
      .el-select-dropdown__item.selected {
        color: #318bc8;
      }
      .team-name {
        text-align: left;
      }
    }
  }
  .option-f {
    .el-select {
      .el-input {
        .el-select__caret {
          color: #b9a2c9;
        }
        .el-input__inner {
          border: 1px solid #b9a2c9;
          border-radius: 14.5px;
          color: #b9a2c9 !important;
        }
      }
      .el-select-dropdown__item.selected {
        color: #b9a2c9;
      }
    }
  }

  .groupContainer {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;

    .container {
      width: 90%;
      height: 200px;
      border-radius: 10px;
      margin: 40px;
      box-shadow: 3px 0px 5px 1px rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .tab-header {
    display: flex;
    flex-direction: row;
  }

  .tab {
    padding: 10px 20px;
    cursor: pointer;
  }

  .active {
    background-color: #ccc;
  }

  .tab-content {
    margin-top: 20px;
  }
}
</style>

<style lang="scss" scoped>
.match-com {
  .match-tit {
    background: #318bc8;
    line-height: 60px;
    text-align: left;
    padding-left: 35px;
    color: #fff;
    font-size: 20px;
    // border: 2px solid #fff;
    border-top: none;
  }
  .match-tab {
    .tab .month-box {
      overflow: hidden;
      margin-bottom: 2px;
      display: flex;
      margin-top: 15px;
      border-bottom: 2px solid rgb(238, 236, 236);
      justify-content: space-around;
    }
    .tab .month-box .month {
      list-style: none;
      text-align: center;
      cursor: pointer;
      font-size: 17px;
      color: #8d929b;
      padding: 0 10px;
    }
    .tab .month-box .month.active {
      // background-color: orange;
      color: #2d3b51;
      font-weight: 600;
      border-bottom: 3px solid #2d3b51;
    }
    .tab {
      .show-box {
        width: 100%;
        height: 100%;
        text-align: center;
        display: none;
        .tab-content:hover {
          background: #eff5fa;
        }
        .tab-content {
          display: flex;
          justify-content: space-around;
          border-bottom: 2px solid #c5cfe348;
          // margin-top: 30px;
          .play-box {
            width: 20%;
            height: 100px;
            margin: 10px;
            padding-top: 10px;
          }
          .play-time,
          .play-tit,
          .play-stats {
            line-height: 25px;
            width: 17%;
            color: #2d3b51;
          }
          .play-stats {
            width: 8%;
          }
          .play-team1,
          .play-team2 {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            // padding-top: 30px;
            .play-txt1 {
              width: 33.3%;
              text-align: right;

              // padding: 10px;
              .sp1 {
                color: #5aa2d3;
              }
              .sp2 {
                font-size: 18px;
                font-weight: 600;
                color: #2d3b51;
              }
            }
            .play-txt2 {
              width: 33.3%;
              margin: 0 20px;
              margin-top: -10px;
              img {
                border-radius: 10px;
              }
            }
            .play-txt3 {
              width: 33.3%;
              font-size: 30px;
              font-weight: 600;
              color: #c2cfe5;
            }
          }
        }

        .play-stats {
          p {
            margin-top: 30px;
            cursor: pointer;
          }
          i {
            color: #5aa2d3;
          }
          :hover {
            color: #888888;
          }
        }
      }
    }

    .tab .show-box.current {
      display: block;
    }
  }
  .group-title {
    line-height: 1.5;
    font-size: 1.5rem;
    color: #2d3b51;
    margin-bottom: 1rem;
  }

  .content-box:hover {
    background-color: #8da9db;
  }

  .link-container {
    text-align: left;
    display: flex;
    align-items: center;
    gap: 5px;
    padding-left: 10px;
    border-radius: 5px;
    cursor: pointer;

    .content-box {
      text-align: left;
      display: flex;
      align-items: center;
      border-radius: 5px;
    }

    h3 {
      margin: 10px !important;
      font-size: 19px;
    }

    a {
      text-decoration: none;
      display: block;
      font-size: 19px;
      line-height: 1.42857143;
      margin: 10px !important;
      // margin-block-start: 1em;
      // margin-block-end: 1em;
      // margin-inline-start: 0px;
      // margin-inline-end: 0px;
      font-weight: bold;
      color: black;
    }

    a:visited {
      text-decoration: none;
    }

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    img:hover {
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 900px) {
  .groupContainer {
    grid-template-columns: repeat(2, 1fr);
    .containerA,
    .containerB {
      width: 70%;
      height: 150px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

@media screen and (max-width: 725px) {
  .groupContainer {
    grid-template-columns: repeat(1, 1fr);
    .containerA,
    .containerB {
      width: 50%;
      height: 150px;
      margin-top: 10px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

@media screen and (max-width: 768px) {
  .tab {
    overflow-x: scroll;
    .tab-content {
      flex-direction: column;
      .play-box {
        line-height: 25px;
        width: 90% !important;
        margin-left: 5% !important;
        height: auto !important;
      }
      .play-time {
        order: 1;
        display: flex;
        justify-content: space-between;
      }
      .play-tit {
        order: 2;
        // display: flex;
        // justify-content: space-between;
        // font-weight: 600;
      }
      .play-team1 {
        order: 3;
        .play-txt1 {
          text-align: left !important;
        }
      }
      .play-team2 {
        order: 4;
        .play-txt3 {
          order: 3;
        }
        .play-txt2 {
          order: 2;
        }
        .play-txt1 {
          order: 1;
          text-align: left;
        }
      }
      .play-stats {
        order: 5;
      }
    }
    .tab-content:nth-child(2n-1) {
      background: rgba(217, 230, 243, 0.363) !important;
    }
  }
}
</style>
